import { cn } from '@/shared/utils/cn';
import React from 'react';
import { ListItemRadio } from '../molecules/ListItemRadio';

export interface ListWithRadioItem {
  id: string;
  label: string;
  count?: string | number;
  disabled?: boolean;
}

export interface ListWithRadioProps {
  items: ListWithRadioItem[];
  selectedValue?: string;
  onSelectionChange?: (itemId: string) => void;
  className?: string;
}

export const ListWithRadio: React.FC<ListWithRadioProps> = ({
  items,
  selectedValue,
  onSelectionChange,
  className,
}) => {
  return (
    <div
      className={cn(
        'ui-rounded-surface-card ui-border ui-border-default ui-bg-fill ui-p-8 ui-shadow-03',
        'ui-min-w-[195px]',
        className
      )}
    >
      <div className="ui-flex ui-flex-col ui-gap-8">
        {items.map((item) => (
          <ListItemRadio
            key={item.id}
            selected={selectedValue === item.id}
            disabled={item.disabled}
            onClick={() => !item.disabled && onSelectionChange?.(item.id)}
            rightContent={item.count ? `(${item.count})` : undefined}
          >
            {item.label}
          </ListItemRadio>
        ))}
      </div>
    </div>
  );
};
